.root {
    width: 100%;
    padding: 0 4px 8px;
    background-color: #ffffff;
}

/* Outer container: funnel-card shadow + padding, fills remaining viewport. */
.container {
    position: relative;
    display: flex;
    height: calc(100vh - 100px);
    margin: 8px 16px;
    background: #fff;
    border: 1px solid #e7e9e6;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(16, 28, 22, 0.08), 0 8px 24px rgba(16, 28, 22, 0.06);
    overflow: hidden;
}

.calendarPane {
    flex: 1;
    min-width: 0;
    height: 100%;
    padding: 8px 12px;
}

/*
 * Right sidebar in normal flow (not absolute) so opening it shrinks the
 * calendar pane rather than overlaying it. Width animates between 0 and 240px.
 */
.drawer {
    position: relative;
    height: 100%;
    width: 0;
    flex-shrink: 0;
    background: #fff;
    border-left: 1px solid #e7e9e6;
    box-shadow: -18px 0 48px rgba(16, 28, 22, 0.1);
    transition: width 0.26s cubic-bezier(0.32, 0.72, 0.3, 1);
    overflow: hidden;
    z-index: 5;
}

.drawerOpen {
    width: 240px;
}

.drawerInner {
    width: 240px;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-width: 0;
    padding: 16px;
    overflow-y: auto;
    overflow-x: hidden;
}

/* Chevron toggle pinned to the middle of the calendar/sidebar boundary. */
.drawerToggle {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 6;
    width: 24px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 1px solid #e7e9e6;
    border-right: none;
    border-radius: 8px 0 0 8px;
    box-shadow: -4px 0 12px rgba(16, 28, 22, 0.08);
    cursor: pointer;
    color: #5f6368;
    transition: right 0.26s cubic-bezier(0.32, 0.72, 0.3, 1);
    right: 0;
}

.drawerToggleOpen {
    right: 240px;
}

.eventContent {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.25;
}

.dayHeader {
    padding: 8px 0;
}

.dayHeaderWeekday {
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-size: 11px;
    font-weight: 600;
    color: #70757a;
}

.dayHeaderWeekdayToday {
    color: #15a05f;
}

.dayHeaderDate {
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: transparent;
}

.dayHeaderDateToday {
    background-color: #15a05f;
}

.dayHeaderDateText {
    font-size: 14px;
    font-weight: 400;
    color: #3c4043;
}

.dayHeaderDateTextToday {
    font-weight: 500;
    color: #fff;
}

.toolbar {
    padding: 0px 8px 6px;
}

.todayButton {
    border-radius: 999px !important;
    text-transform: none !important;
    padding: 5px 14px !important;
    font-weight: 600 !important;
    color: #15a05f !important;
    border-color: #dadce0 !important;
}

.navigationButton {
    color: #70757a !important;
}

.navigationButton:global(.Mui-disabled) {
    color: #c4c8cc !important;
}

.periodButton {
    margin-left: 4px !important;
    text-transform: none !important;
    font-size: 18px !important;
    font-weight: 500 !important;
    color: #3c4043 !important;
}

.periodButton :global(.MuiButton-endIcon) {
    color: #70757a;
}

.tourPopover {
    width: 360px;
    border-radius: 8px !important;
    padding: 0;
}

.popoverActions {
    padding: 8px 8px 0;
}

.confirmedButton {
    background-color: #15a05f !important;
    color: #fff !important;
}

.confirmedButton:hover {
    background-color: #12884f !important;
}

.popoverBody {
    padding: 0 24px 24px;
}

.popoverAccent {
    width: 14px;
    height: 14px;
    border-radius: 4px;
    margin-top: 6px;
    flex-shrink: 0;
}

.popoverHeaderText {
    min-width: 0;
    flex: 1;
}

.popoverTitle {
    line-height: 1.2 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.popoverTitleLink {
    cursor: pointer;
}

.popoverTitleLink:hover {
    text-decoration: underline;
}

.popoverTitleCanceled {
    text-decoration: line-through;
    color: rgba(0, 0, 0, 0.38);
}

.popoverDetails {
    margin-top: 20px;
}

.confirmedBadge {
    padding: 2px 7px;
    border-radius: 999px;
    background-color: #e8f7ef;
    color: #138a52;
    font-size: 12px;
    font-weight: 500;
}

.detailIcon {
    width: 18px;
    color: rgba(0, 0, 0, 0.6);
    flex-shrink: 0;
}

.detailText {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.emptyLegend {
    font-size: 12px !important;
    color: #9aa1ab;
}

.legendItem {
    min-width: 0;
    width: 100%;
    padding: 8px;
    border-radius: 6px;
    cursor: pointer;
    background-color: transparent;
}

.legendItem:hover {
    background-color: #f5f6f5;
}

.legendItemSelected {
    background-color: transparent;
}

.legendCheckbox {
    padding: 0 !important;
    color: #bcc2c9 !important;
}

.legendCheckbox:global(.Mui-checked) {
    color: #15a05f !important;
}

.legendColor {
    width: 16px;
    height: 12px;
    border-radius: 3px;
    background-color: #fff;
    border: 1px solid #e6e8eb;
    border-left-width: 4px;
    flex-shrink: 0;
}

.legendName {
    min-width: 0;
    max-width: 100%;
    flex: 1;
    font-size: 12px !important;
    color: #3c4043;
    font-weight: 400 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.legendNameSelected {
    font-weight: 600 !important;
}

/* Child (unit) rows sit indented under their root parent's header row. */
.legendChildItem {
    padding: 6px 8px 6px 28px;
}

.legendGroupName {
    font-weight: 600 !important;
}

.root :global(.rbc-time-view),
.root :global(.rbc-month-view),
.root :global(.rbc-time-header),
.root :global(.rbc-time-content),
.root :global(.rbc-day-bg),
.root :global(.rbc-time-column),
.root :global(.rbc-header) {
    background-color: #ffffff;
}

.root {
    font-family: 'DM Sans', system-ui, sans-serif;
}

/* 56px hour rows (two 28px half-hour slots), light hairlines. */
.root :global(.rbc-time-slot) {
    min-height: 28px;
}

.root :global(.rbc-timeslot-group) {
    min-height: 56px;
    border-bottom: 1px solid #e8eaed;
}

.root :global(.rbc-time-content) {
    border-top: 1px solid #e8eaed;
}

/* Only on-the-hour lines: remove the half-hour (:30) slot divider. */
.root :global(.rbc-day-slot .rbc-time-slot),
.root :global(.rbc-time-content > * + * > *) {
    border-top: none;
}

@media (hover: hover) and (pointer: fine) {
    .root :global(.rbc-events-container) {
        pointer-events: none;
    }

    .root :global(.rbc-event) {
        pointer-events: auto;
    }

    .root :global(.rbc-day-slot .rbc-time-slot) {
        cursor: pointer;
        transition: background-color 120ms ease;
    }

    .root :global(.rbc-day-slot .rbc-time-slot:hover) {
        background-color: #eaf7f0;
    }
}

.root :global(.rbc-time-header-content),
.root :global(.rbc-time-content),
.root :global(.rbc-day-bg + .rbc-day-bg),
.root :global(.rbc-month-view),
.root :global(.rbc-month-row + .rbc-month-row),
.root :global(.rbc-header),
.root :global(.rbc-time-view) {
    border-color: #e8e8e8;
}

/*
 * Native buttons don't inherit the page font, and react-big-calendar's
 * .rbc-button-link leaves font unset — so month date numbers and the
 * "+N more" link render in the UA font instead of DM Sans.
 */
.root :global(.rbc-button-link) {
    font: inherit;
}

/*
 * Month date numbers: same typography as the week/day header dates
 * (14px/400/#3c4043), centered, with today marked by the same filled accent
 * circle instead of rbc's default bold weight.
 */
.root :global(.rbc-month-view .rbc-date-cell) {
    padding: 4px 0 2px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #3c4043;
}

.root :global(.rbc-month-view .rbc-date-cell.rbc-now) {
    font-weight: 400;
}

.root :global(.rbc-month-view .rbc-date-cell .rbc-button-link) {
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}

.root :global(.rbc-month-view .rbc-date-cell .rbc-button-link:hover) {
    background-color: #f1f3f4;
}

.root :global(.rbc-month-view .rbc-date-cell.rbc-now .rbc-button-link) {
    background-color: #15a05f;
    color: #fff;
    font-weight: 500;
}

.root :global(.rbc-month-view .rbc-date-cell.rbc-now .rbc-button-link:hover) {
    background-color: #12884f;
}

.root :global(.rbc-month-view .rbc-off-range) {
    color: #9aa1ab;
}

/* "+N more" overflow link: palette typography instead of rbc's bold blue. */
.root :global(.rbc-month-view .rbc-show-more) {
    margin: 0 4px;
    padding: 1px 3px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    color: #70757a;
    background-color: transparent;
}

.root :global(.rbc-month-view .rbc-show-more:hover),
.root :global(.rbc-month-view .rbc-show-more:focus) {
    color: #3c4043;
    background-color: #f1f3f4;
}

/* Time gutter labels (incl. the GMT offset) sit small and muted. */
.root :global(.rbc-label),
.root :global(.rbc-time-gutter .rbc-timeslot-group) {
    font-size: 11px;
    color: #70757a;
}

.root :global(.rbc-time-gutter .rbc-timeslot-group) {
    border-bottom: none;
}

/* Remove the heavy default header underline; our custom header has its own. */
.root :global(.rbc-header) {
    border-bottom: none;
    padding: 0;
}

.root :global(.rbc-time-view .rbc-header) {
    height: auto;
    min-height: 58px;
    overflow: visible;
}

/* Month weekday header: same typography as the week/day header weekday row. */
.root :global(.rbc-month-view .rbc-header) {
    min-height: 0;
    padding: 8px 0 2px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-size: 11px;
    font-weight: 600;
    color: #70757a;
}

.root :global(.rbc-time-header),
.root :global(.rbc-time-header-content),
.root :global(.rbc-time-header-cell) {
    overflow: visible;
}

/*
 * Make the time grid fill the container and scroll internally. Without a bounded
 * view height, react-big-calendar renders the full day with no scroll, so early
 * hours (before the scrollToTime position) become unreachable.
 */
.root :global(.rbc-time-view) {
    height: 100%;
}

/*
 * react-big-calendar applies a *fluctuating* inline margin-right to the header
 * content (measured async via dom-helpers scrollbarSize) to compensate for the
 * body's scrollbar width. That async measurement is what causes the
 * "misaligned, then snaps into place" flash on view switch.
 *
 * Fix: make the body scrollbar overlay-style with zero layout width, so there's
 * no scrollbar inset to compensate for, then pin the header margin to 0. Header
 * and body columns then align identically from the first frame.
 */
.root :global(.rbc-time-content) {
    flex: 1 1 auto;
    overflow-y: auto;
    scrollbar-width: none;
}

.root :global(.rbc-time-content)::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.root :global(.rbc-time-header),
.root :global(.rbc-time-header-content) {
    margin-right: 0 !important;
}

/* Keep the grid uniformly white, including today's column. */
.root :global(.rbc-today) {
    background-color: #ffffff;
}

/*
 * Hide the all-day events row under the day headers. Tours are always timed
 * (30-min slots), so this row is always empty and just adds a blank band. In
 * day view the cell is nested in the single-day header cell, so collapse both.
 */
.root :global(.rbc-allday-cell) {
    display: none !important;
    height: 0 !important;
    min-height: 0 !important;
}

.root :global(.rbc-time-header-content > .rbc-row.rbc-row-resource) {
    display: none;
}

/*
 * Lock the day-column header to the same width as the grid columns below by
 * keeping the gutter widths identical between the time header and time content.
 * react-big-calendar measures the gutter; forcing a fixed gutter prevents the
 * header columns from drifting out of alignment with the slot columns.
 */
.root :global(.rbc-time-header-gutter),
.root :global(.rbc-time-gutter) {
    width: 64px;
    min-width: 64px;
    max-width: 64px;
    box-sizing: border-box;
}

/* Uniform row height so every hour cell is exactly the same size. */
.root :global(.rbc-day-slot .rbc-timeslot-group),
.root :global(.rbc-time-gutter .rbc-timeslot-group) {
    min-height: 56px;
    max-height: 56px;
}

/*
 * Event cards (white fill + colored left bar) are styled inline via
 * eventPropGetter, so avoid overriding their border/background here. Only set
 * layout that the inline styles don't.
 */
.root :global(.rbc-event) {
    font-size: 12px;
    padding: 3px 8px;
}

.dayView :global(.rbc-event) {
    max-width: calc(80%);
}

.root :global(.rbc-event.rbc-selected) {
    box-shadow: 0 0 0 2px #fff, 0 0 0 3px currentColor;
}

/* Hide react-big-calendar's built-in event time label; cards show name only. */
.root :global(.rbc-event-label) {
    display: none;
}

/* Red "now" indicator line + dot. */
.root :global(.rbc-current-time-indicator) {
    height: 2px;
    background-color: #ea4335;
}

.root :global(.rbc-current-time-indicator)::before {
    content: '';
    position: absolute;
    left: -5px;
    top: -4px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #ea4335;
}
